module.exports = __webpack_public_path__ + "img/shipo-icon-close.eb1d0ad6.svg";